import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { UserData } from "../types/org.type";
import axios from "axios";
import { rem } from "@mantine/core";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface RegtankLivenessReattemptApproval {
  token: string;
  sessionId: string;
  remark: string;
  reattemptApproval: string;
  userId: string;
  userData?: UserData;
}

const updateRegtankLivenessReattemptApproval = async ({
  token,
  sessionId,
  remark,
  reattemptApproval,
  userId,
  userData,
}: RegtankLivenessReattemptApproval) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/users/update-reattempt-regtank-liveness-approval`,
      { sessionId, remark, reattemptApproval, userId, userData },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    (e as Error).message = message;
    throw e;
  }
};

export default updateRegtankLivenessReattemptApproval;
